<template>
  <div class="wrapper-register">
    <div class="bg-color"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-12 mx-auto">
          <div class="card card-signup my-3">
            <div class="card-body">
              <div class="text-center" style="padding-bottom: 30px">
                <h2 style="color:#fff">Cadastro de Usuário</h2>
              </div>
              <form class="form-signup">
                <div class="row">
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="name"
                        type="name"
                        id="inputName"
                        class="form-control"
                        placeholder="Name"
                        required
                        autofocus
                      />
                      <div class="invalid-feedback">
                        Por favor, digite o seu nome.
                      </div>
                      <label for="inputName">Informe o nome</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="email"
                        type="email"
                        id="inputEmail"
                        class="form-control"
                        placeholder="Email"
                        required
                        autofocus
                      />
                      <div class="invalid-feedback">
                        Por favor, informe um e-mail.
                      </div>
                      <label for="inputEmail">Informe o e-mail</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        @blur="maskCellphone"
                        type="telephone"
                        id="inputPhone"
                        class="form-control"
                        placeholder="Telefone"
                        required
                        maxlength="11"
                        size="11"
                      />
                      <div class="invalid-feedback">
                        Por favor, informe o número.
                      </div>
                      <label for="inputPhone"
                        >Informe o celular (apenas números)</label
                      >
                    </div>
                  </div>
                  <!--
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        @blur="maskCpf"
                        type="text"
                        id="inputCPF"
                        class="form-control"
                        placeholder="CPF"
                        required
                        maxlength="14"
                        size="11"
                      />
                      <div class="invalid-feedback">
                        Por favor, informe um CPF válido.
                      </div>
                      <label for="inputCPF">Informe o CPF</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="birthday"
                        type="date"
                        id="inputBirthday"
                        class="form-control"
                        placeholder="Data de nascimento"
                        required
                        autofocus
                      />
                      <div class="invalid-feedback">
                        Por favor, informe a data de nascimento.
                      </div>
                      <label for="inputBirthday"
                        >Informe a data de nascimento</label
                      >
                    </div>
                  </div>
                  -->
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="occupation"
                        type="text"
                        id="inputOccupation"
                        class="form-control"
                        placeholder="Telefone"
                        required
                        autofocus
                      />
                      <div class="invalid-feedback">
                        Por favor, informe o cargo.
                      </div>
                      <label for="inputOccupation">Informe o cargo</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-label-group">
                      <select
                        id="departament"
                        class="form-control"
                        required
                        autofocus
                        v-model="department"
                      >
                        <option selected value="0"
                          >Informe o departamento</option
                        >
                        <option value="Vendas">Vendas</option>
                        <option value="Pós-Vendas">Pós-Vendas</option>
                        <option value="Administrativo">Administrativo</option>
                        <option value="Financeiro">Financeiro</option>
                        <option value="RH">RH</option>
                        <option value="Qualidade">Qualidade</option>
                        <option value="Marketing">Marketing</option>
                      </select>
                      <div class="invalid-feedback">
                        Por favor, informe o departamento.
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="city"
                        type="text"
                        id="inputCity"
                        class="form-control"
                        placeholder="Cidade"
                        required
                        autofocus
                      />
                      <div class="invalid-feedback">
                        Por favor, informe a cidade.
                      </div>
                      <label for="inputCity">Informe a cidade</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        @blur="maskCnpj"
                        type="text"
                        id="inputCNPJ"
                        class="form-control"
                        placeholder="CNPJ"
                        maxlength="18"
                        size="18"
                      />
                      <div class="invalid-feedback">
                        Por favor, informe um CNPJ válido.
                      </div>
                      <label for="inputCNPJ">Informe o CNPJ</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <button
                      type="button"
                      v-b-modal.modal-dealers
                      class="btn btn-block btn-secondary"
                    >
                      Adicionar Dealer
                    </button>
                    <modal-dealers :userDealers="addedDealers" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="password1"
                        type="password"
                        id="password1"
                        class="form-control"
                        placeholder="Password"
                        required
                      />
                      <div class="invalid-feedback">
                        Por favor, insira uma senha.
                      </div>
                      <label for="password1">Informe a senha</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-label-group">
                      <input
                        v-model="password2"
                        type="password"
                        id="password2"
                        class="form-control"
                        placeholder="Password"
                        required
                      />
                      <div class="invalid-feedback">
                        Por favor, insira a mesma senha.
                      </div>
                      <label for="password2">Confirme a senha</label>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row">
                  <div class="col-12">
                    <div class="text-center">
                      <h2 style="color:#fff">Concessionários Adicionados:</h2>
                      <div class="chips-columns mt-4">
                        <div v-if="addedDealers.length === 0">
                          <span style="font-style: italic;">Nenhum</span>
                        </div>
                        <div v-for="(item, i) in addedDealers" :key="i">
                          <div ref="chip" class="chip">
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      class="btn btn-primary text-uppercase send-button"
                      type="button"
                      v-b-modal.modal-lg
                    >
                      Enviar Solicitação
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-lg"
      size="lg"
      title="TERMO DE CONHECIMENTO E RESPONSABILIDADE – BI ASSOBENS"
    >
      <p>
        Pela presente, declaro estar ciente dos termos e condições de uso do BI
        da Associação Brasileira dos Concessionários Mercedes-Benz, tomando
        total ciência do seu conteúdo, razão pela qual assumo integralmente o
        compromisso de não divulgar as informações ali constantes para terceiros
        que não esteja direta ou indiretamente envolvidos no negócio
        Mercedes-Benz, e desde já, autorizo a utilização dos dados preenchidos
        para envio de correspondências e informativos da Associação.
      </p>

      <template v-slot:modal-footer="{ ok, cancel }">
        <b>Estou ciente e concordo com os termos acima</b>
        <b-button size="sm" variant="primary" @click="send">
          Aceitar
        </b-button>
        <b-button size="sm" variant="secondary" @click="cancel()">
          Recusar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ModalDealers from '../../../organisms/modal-dealers/index.vue';
import EventBus from '../../../../eventBus';

const BrM = require('br-masks');
const validator = require('cpf-cnpj-validator');

export default {
  name: 'Register',

  components: { ModalDealers },

  data: () => ({
    showOptions: false,
    name: null,
    email: null,
    cellPhone: null,
    birthday: null,
    cpf: null,
    occupation: null,
    department: '0',
    city: null,
    cnpj: null,
    password1: null,
    password2: null,
    checked: false,
    addedDealers: [],
    initialDataConfiguration: null,
  }),

  created() {
    this.initialDataConfiguration = this.$data;
  },

  mounted() {
    EventBus.$on('saveUserDealers', (dealers) => {
      this.addedDealers = dealers;
    });
  },

  methods: {
    ...mapActions('dealers', ['getDealers', 'sendRegister']),
    ...mapActions('users', ['sendRegister']),

    maskCellphone(event) {
      const number = event.target.value.replace(/[^\d]+/g, '');
      let mask;
      if (number.length > 9) {
        const isCellphone = number.length === 11;

        // eslint-disable-next-line
        mask = number.replace(/\-/g, '');

        if (isCellphone) {
          const ddd = mask.slice(0, 2);
          const ninthDigit = mask.slice(2, 3);
          const firstPart = mask.slice(3, 7);
          const lastPart = mask.slice(7, 11);
          mask = `(${ddd}) ${ninthDigit} ${firstPart}-${lastPart}`;
        } else {
          const ddd = mask.slice(0, 2);
          const firstPart = mask.slice(2, 6);
          const lastPart = mask.slice(6, 10);
          mask = `(${ddd}) ${firstPart}-${lastPart}`;
        }
        // eslint-disable-next-line
        event.target.value = mask;
        event.target.classList.remove('is-invalid');
        this.cellPhone = mask;
      } else {
        this.cellPhone = number;
        event.target.classList.add('is-invalid');
      }
      // eslint-disable-next-line
      event.target.value = mask;
      this.cellPhone = mask;
    },

    maskCpf(event) {
      const $cpf = document.getElementById('inputCPF');
      if (event.target.value.length > 10) {
        this.cpf = BrM.cpf(event.target.value.replace(/[^\d]+/g, ''));
        // eslint-disable-next-line
        event.target.value = BrM.cpf(event.target.value.replace(/[^\d]+/g, ''));
        if (!validator.cpf.isValid(event.target.value.replace(/[^\d]+/g, ''))) {
          $cpf.classList.add('is-invalid');
          return false;
        }
      }
      $cpf.classList.remove('is-invalid');
      return false;
    },
    maskCnpj(event) {
      const $cnpj = document.getElementById('inputCNPJ');
      if (event.target.value.length > 10) {
        this.cnpj = BrM.cnpj(event.target.value.replace(/[^\d]+/g, ''));
        // eslint-disable-next-line
        event.target.value = BrM.cnpj(
          event.target.value.replace(/[^\d]+/g, ''),
        );
        if (
          !validator.cnpj.isValid(event.target.value.replace(/[^\d]+/g, ''))
        ) {
          $cnpj.classList.add('is-invalid');
          return false;
        }
      }
      $cnpj.classList.remove('is-invalid');
      return false;
    },

    async send() {
      if (this.validateFields()) {
        try {
          if (this.addedDealers.length > 0) {
            await this.sendRegister({
              name: this.name,
              email: this.email,
              celphone: this.cellPhone,
              birthday: this.birthday,
              cpf: this.cpf,
              occupation: this.occupation,
              department: this.department,
              city: this.city,
              cnpj: this.cnpj,
              password: this.password1,
              dealers: this.addedDealers,
            });

            this.$swal(
              'Sucesso!',
              'Sua solicitação foi enviada para análise e em breve será respondida. Seu cadastro será liberado em até 24hrs.',
              'success',
            );

            Object.assign(this.$data, this.$options.data.call(this));

            this.$router.push('login');

            const $checkboxes = document.querySelectorAll(
              '.custom-control-input',
            );
            $checkboxes.forEach((el) => {
              // eslint-disable-next-line
              el.checked = false;
            });
          } else {
            this.$swal(
              'Dados Incompletos!',
              'Informe um concessionário para continuar.',
              'warning',
            );
          }
        } catch (error) {
          this.$swal('Falhou!', `${error.response.data.message}`);
        }
      }
    },

    validateFields() {
      const $name = document.getElementById('inputName');
      const $email = document.getElementById('inputEmail');
      const $pass1 = document.getElementById('password1');
      const $pass2 = document.getElementById('password1');
      const $phone = document.getElementById('inputPhone');
      const $occupation = document.getElementById('inputOccupation');
      const $department = document.getElementById('departament');
      // const $cpf = document.getElementById('inputCPF');
      // const $birthday = document.getElementById('inputBirthday');
      const $city = document.getElementById('inputCity');
      const $cnpj = document.getElementById('inputCNPJ');

      $name.classList.remove('is-invalid');
      $phone.classList.remove('is-invalid');
      $email.classList.remove('is-invalid');
      $occupation.classList.remove('is-invalid');
      $department.classList.remove('is-invalid');
      $pass1.classList.remove('is-invalid');
      $pass2.classList.remove('is-invalid');
      // $cpf.classList.remove('is-invalid');
      // $birthday.classList.remove('is-invalid');
      $city.classList.remove('is-invalid');
      $cnpj.classList.remove('is-invalid');

      if (!this.name) {
        $name.classList.add('is-invalid');
        return false;
      }

      if (!this.email) {
        $email.classList.add('is-invalid');
        return false;
      }

      if (!this.cellPhone) {
        $phone.classList.add('is-invalid');
        return false;
      }
      /*
      if (!this.cpf) {
        $cpf.classList.add('is-invalid');
        return false;
      }

      if (!this.birthday) {
        $birthday.classList.add('is-invalid');
        return false;
      }
      */

      if (!this.occupation) {
        $occupation.classList.add('is-invalid');
        return false;
      }

      if (this.department === '0') {
        $department.classList.add('is-invalid');
        return false;
      }

      if (!this.city) {
        $city.classList.add('is-invalid');
        return false;
      }

      if (!this.cnpj) {
        $cnpj.classList.add('is-invalid');
        return false;
      }

      if (!this.password1) {
        $pass1.classList.add('is-invalid');
        return false;
      }

      if (!this.password2) {
        $pass2.classList.add('is-invalid');
        return false;
      }

      if (this.password1 !== this.password2) {
        $pass2.classList.add('is-invalid');
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss">
.dropdown {
  width: 100%;
}

.dropdown-menu li {
  min-width: 250px !important;
}

.chip {
  padding: 3px 15px;
  font-size: 10px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: #303030;
  color: #fff;
  display: flex;
  align-items: center;
}

.chips-columns {
  max-height: 135px;
  overflow: auto;
}

.send-button {
  min-width: 300px;
}
</style>

<style>
.drop-assobens .dropdown-menu {
  max-height: 100px !important;
  width: 100%;
  overflow: auto;
}

:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.wrapper-register {
  background: url('../../../../assets/bg_login.png');
  height: 100vh;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  overflow: auto;
}

.card-signup {
  border: 0;
  border-radius: 1rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.card-signup .card-title {
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1.5rem;
}

.card-signup .card-body {
  padding: 1.6rem;
}

.form-signup {
  width: 100%;
}

.form-signup .btn {
  font-size: 80%;
  border-radius: 5rem;
  letter-spacing: 0.1rem;
  font-weight: bold;
  padding: 1rem;
  transition: all 0.2s;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group input {
  height: auto;
  border-radius: 2rem;
}

.form-label-group select {
  height: auto;
  border-radius: 2rem;
}

.form-select button {
  height: auto;
  border-radius: 2rem;
}

.form-label-group > input,
.form-label-group > label {
  padding: var(--input-padding-y) var(--input-padding-x);
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: all 0.1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
  padding-bottom: calc(var(--input-padding-y) / 3);
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: calc(var(--input-padding-y) / 3);
  padding-bottom: calc(var(--input-padding-y) / 3);
  font-size: 12px;
  color: #777;
}

.btn-google {
  color: white;
  background-color: #ea4335;
}

.btn-facebook {
  color: white;
  background-color: #3b5998;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}

/* Fallback for IE
-------------------------------------------------- */

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .form-label-group > label {
    display: none;
  }
  .form-label-group input:-ms-input-placeholder {
    color: #777;
  }
}

.card {
  /* background-color: transparent !important; */
  background-color: transparent !important;
  border: none !important;
}
.bg-color {
  position: fixed;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
</style>
